$(document).ready(function(){

    const $kakaoLogin=$(".js_kakao_login");
    if($kakaoLogin.length)
    {
        $kakaoLogin.click(function(){
            let return_url=window.location.origin;
            const query_string=window.location.search; 
            const url_params=new URLSearchParams(query_string);
            if(url_params.get("return_url")) return_url=url_params.get("return_url");
            if(return_url.substr(0,1)=="/") return_url=window.location.origin+return_url;

            const url="https://kr.dreametech.com/member/kakao/kakao_login.php?kakaoType="+$(this).data("kakao-type")+"&returnUrl="+encodeURIComponent(return_url);
            const width=480;
            const height=730;
            const top=(screen.height-730)/2;
            const left=(screen.width-width)/2;
            const option="top="+top+",left="+left+",width="+width+",height="+height+",resizable=no,scrollbars=no";
            window.open(url,"kakaoLogin",option);
        });
    }

});